














































































































import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import AnxAlert from "../AnxAlert/AnxAlert.vue";
import AnxButton from "../AnxButton/AnxButton.vue";
import AnxCheckbox from "../AnxCheckbox/AnxCheckbox.vue";
import AnxContainer from "../AnxContainer/AnxContainer.vue";
import AnxContent from "../AnxContent/AnxContent.vue";
import AnxForm from "../AnxForm/AnxForm.vue";
import AnxHrLine from "../AnxHrLine/AnxHrLine.vue";
import AnxIcon from "../AnxIcon/AnxIcon.vue";
import AnxInput from "../AnxInput/AnxInput.vue";

/**
 * This component renders a highly adjustable login form that matches the style guidelines
 */
@Component({
  components: {
    AnxAlert,
    AnxButton,
    AnxCheckbox,
    AnxContainer,
    AnxContent,
    AnxForm,
    AnxHrLine,
    AnxIcon,
    AnxInput
  }
})
export default class AnxLogin extends Vue {
  /** The width of the login form */
  @Prop({ default: "400px" }) width!: string;

  /** This is the src for the logo in the header */
  @Prop({ default: null }) logo!: string | null;

  /** This is the src attribute of the customer logo */
  @Prop({ default: null }) customerLogo!: string | null;

  /** If this is not null, the string will be displayed as error */
  @Prop({ default: null }) loginError!: string | null;

  /** Modify the username input */
  /** The name of the username field */
  @Prop({ default: "username" }) usernameName!: string;
  /** The id of the username field */
  @Prop({ default: "username-input" }) usernameId!: string;
  /** The label for the username field */
  @Prop({ default: "Username" }) usernameLabel!: string;
  /** The rules for the username field */
  @Prop({ default: "required" }) usernameRules!: string;
  /** The assistive text for the username field */
  @Prop({ default: "" }) usernameAssistiveText!: string;

  /** Modify the password input */
  /** The name of the password field */
  @Prop({ default: "password" }) passwordName!: string;
  /** The id of the password field */
  @Prop({ default: "password-input" }) passwordId!: string;
  /** The label for the password field */
  @Prop({ default: "Password" }) passwordLabel!: string;
  /** The rules for the password field */
  @Prop({ default: "required" }) passwordRules!: string;
  /** The assistive text for the password field */
  @Prop({ default: "" }) passwordAssistiveText!: string;

  /** Modify the submit button */
  /** The width of the submit button */
  @Prop({ default: null }) submitButtonWidth!: string | null;
  /** The text of the submit button */
  @Prop({ default: "Log in" }) submitButtonText!: string;
  /** The align of the submit button */
  @Prop({ default: "right" }) submitButtonAlign!: string;

  /** Modify the footer */
  /** This property can be set to hide the footer */
  @Prop({ default: null }) noFooter!: boolean | null;
  /** These are the lines for the text in the footer */
  @Prop({ default: null }) footerText!: Array<string> | null;
  /** The icon of the footer */
  @Prop({ default: "anexia-stamp" }) footerIcon!: string;
  /** The size of the icon of the footer */
  @Prop({ default: "60px" }) footerIconSize!: string;

  /** Option to display a remember me button (The string that is provided, will be displayed as text. If no text is provided, the text is "Remember me") */
  @Prop({ default: null }) rememberMe!: string | null;
  /** The default value for the remember me checkbox */
  @Prop({ default: false }) rememberMeDefault!: boolean;

  /** The variables for username and password */
  private username = "";
  private password = "";
  private rememberMeCheckbox = this.rememberMeDefault;

  /** Shows the error message if this is true */
  private hasLoginError = false;

  /** Watches the error message and sets the variable to show the error if needed */
  @Watch("loginError")
  onLoginErrorChanged(newVal: string) {
    if (newVal === null || !newVal) {
      this.hasLoginError = false;
    } else {
      this.hasLoginError = true;
    }
  }

  /** When the user hits the login button and the entered data passes validation, the login event is emitted */
  @Emit()
  login() {
    return {
      username: this.username,
      password: this.password,
      rememberMe: this.rememberMeCheckbox
    };
  }

  /** Check if the remember me text is set, otherwise return default text */
  private get rememberMeText(): string {
    if (this.rememberMe && this.rememberMe.length > 0) {
      return this.rememberMe;
    }

    return "Remember me";
  }
}
